<template>
	<AssessmentCharacteristics class="energizing-characteristics"
		:is-skeleton="isSkeleton"
		:high-type="highType"
		:characteristics="characteristics"
	>
		<template #icon>
			<FontAwesomeIcon
				:icon="[ `far`, `bolt-lightning` ]"
			/>
		</template>
		<template #heading>{{ $t( "common.EnergizingCharacteristics__heading" ) }}</template>
	</AssessmentCharacteristics>
</template>

<script>
import CommonCharacteristics from "./CommonCharacteristicsProps";
import AssessmentCharacteristics from "./AssessmentCharacteristics";
export default {
	name: "EnergizingCharacteristics",
	mixins: [ CommonCharacteristics, ],
	components: {
		AssessmentCharacteristics,
	},
	computed: {
		characteristics() {
			return this.assessment?.teamingContent?.motivations || [];
		},
	},
};
</script>

<style lang="scss" scoped></style>
